import fetch from './fetch';
import send from './send';

export {
	fetch,
	send,
}
